import SpinnerIcon from "@ui/icons/spinner";

export function FullscreenLoader() {
  return (
    <div className="flex items-center justify-center w-screen h-screen align-middle">
      <SpinnerIcon className="animate-spin w-10 h-10 text-muted-foreground" />
    </div>
  );
}
